import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { Link } from 'react-router-dom';

import { auth } from "./firebaseconfig.js"; // Ensure Firebase is initialized properly
import "./Login.css"
import Forward from '../assets/icons/forward.svg'
import Logo from '../assets/icons/logo.svg'



const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);

  const containerStyle = {
    height: !isExpanded ? '100px' : '150px',
    backgroundColor: 'light-dark( var(--container-tertiary-light), var(--container-tertiary-dark))',
    borderRadius: '20px',
    width: 'auto;',
    display: 'block,',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    transition: 'height 0.3s ease-in-out',
    padding: '3%'
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      window.location.href = "/dash"; 
    } catch (err) {
      setError("Invalid email or password");

    }
    setIsExpanded(true);

  };

  return (
    <>

    <header>
      <Link className = "item-link" to={`/`}>

        <img src = {Logo} className= 'logo'></img>
        </Link>

      </header>
    <div className="login-wrapper-latent">
                <div className = "login-wrapper">

        <h1>Login</h1>

        <div className={`login-wrapper-immediate ${error ? "error" : " " }`} style = {containerStyle}>

        <form onSubmit={handleLogin} className = "login-form">
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <button type="submit" ><img src = {Forward} className =  "bid-forward-button"></img></button>
            </form>
            {error && <p className = "error-message-login">{error}</p>}
        </div>
        </div>
    </div>

    </>
  );
};

export default LoginPage;
